import { TightSectionContent } from '@ui-components/containers/TightSectionContent'
import * as React from 'react'
import { styled } from 'styled-components'

import { AssistantStep, AssistantStepProps } from './AssistantStep'

export type AfterCareStepProps = Omit<AssistantStepProps, 'emoji' | 'topBarVariant'>

const StyledTightSectionContent = styled(TightSectionContent)`
  align-items: start;
`

export const AfterCareStep = ({ children, ...rest }: React.PropsWithChildren<AfterCareStepProps>) => {
  return (
    <AssistantStep
      emoji="indexFingerUp"
      topBarVariant="large"
      twoColumnLayoutSupport={false}
      fullViewportHeight={false}
      {...rest}
    >
      <StyledTightSectionContent>{children}</StyledTightSectionContent>
    </AssistantStep>
  )
}
